module.exports = __webpack_public_path__ + "img/band.e1c7ffc4.jpg";